export const ERROR_MESSAGES = {
  REQUIRED: 'This field is required',
  REQUIRED_TRUE: 'This field requires true value',
  MIN_LENGTH: 'The minimum length of field should be',
  MAX_LENGTH: 'The maximum length of field should be',
  MIN: 'The minimum value should be',
  MAX: 'The maximum valuie should be',
  EMAIL: 'Fill this field in format: name@example.com',
  PATTERN: 'This field does not meet some requirements',
};
